import { BasicButton } from "@/components";
import { isAuthenticating } from "@/libraries/helper";
import { triggerCancel } from "@/redux/reducers/payment";
import { AuthWebviewSchema } from "@/schemas";
import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const Route = createFileRoute("/payment-failed")({
	validateSearch: zodSearchValidator(AuthWebviewSchema),
	beforeLoad: async () => {
		if (!isAuthenticating()) {
			throw redirect({
				to: "/",
				replace: true,
			});
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(triggerCancel());
	}, [dispatch]);
	return (
		<>
			<div className="container wrapper h-full bg-failed">
				<Box className="h-full flex flex-col justify-center items-center px-8">
					<img src="/images/icon-error.svg" alt="icon-error" loading="lazy" />
					<h1 className="text-dark text-[22px] text-center leading-7 font-bold mt-6 mb-2">
						Payment Failed
					</h1>
					<p className="text-gray-100 text-sm text-center mb-6">
						There was an unexpected error. Please try again in a few seconds
					</p>
					<Link to={"/manage-subscription"}>
						<BasicButton
							variant="contained"
							color="secondary"
							className="w-[197px] !h-12 !text-sm !shadow-none"
						>
							<Box className="flex items-center gap-1">
								<RefreshIcon />
								<p>Retry Payment</p>
							</Box>
						</BasicButton>
					</Link>
				</Box>
			</div>
		</>
	);
}
